import { Store } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import type { Store as StoreType } from '@/shared/types/store';

const ALL_VALUE = '__all__';

interface StoreFilterSelectProps {
  value: string;
  stores: StoreType[];
  onChange: (storeCod: string) => void;
  disabled?: boolean;
  className?: string;
  /** Valor enviado no filtro. O rótulo continua o nome da loja. */
  valueFrom?: 'name' | 'branchId';
}

export function StoreFilterSelect({ value, stores, onChange, disabled, className, valueFrom = 'name' }: StoreFilterSelectProps) {
  return (
    <Select
      value={value || ALL_VALUE}
      onValueChange={(v) => onChange(v === ALL_VALUE ? '' : v)}
      disabled={disabled}
    >
      <SelectTrigger className={cn('w-auto gap-1.5 pr-3', className)}>
        <Store className="size-3.5 shrink-0 text-muted-foreground" />
        <SelectValue placeholder="Todas as lojas" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_VALUE}>Todas as lojas</SelectItem>
        {stores.map((store) => {
          const cod = String(store.storeCod ?? '');
          const name = store.storeName ?? '';
          const branchId = store.branchId != null ? String(store.branchId).trim() : '';
          // Nome casa em `storeName`; código, em `stores[]`. Webautomação grava o branchId.
          const filterValue = valueFrom === 'branchId'
            ? branchId
            : name || cod || String(store._id ?? '');
          const label = name || cod;
          if (!filterValue) return null;
          return (
            <SelectItem key={filterValue} value={filterValue}>
              {label}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
